import React from 'react';

const Dialog = ({ children, open, onOpenChange }) => (
    <div className={`fixed inset-0 z-50 ${open ? 'block' : 'hidden'}`}>
        <div className="fixed inset-0 bg-background/80 backdrop-blur-sm" onClick={() => onOpenChange?.(false)} />
        <div className="fixed left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%]">
            {children}
        </div>
    </div>
);

const DialogTrigger = ({ children, onClick, asChild }) => {
    if (asChild) {
        return React.cloneElement(children, { onClick });
    }
    return <button onClick={onClick}>{children}</button>;
};

const DialogContent = ({ children, className = '' }) => (
    <div className={`bg-background rounded-lg border shadow-lg max-w-[90vw] max-h-[90vh] overflow-auto ${className}`}>
        {children}
    </div>
);

const DialogHeader = ({ children, className = '' }) => (
    <div className={`px-6 py-4 border-b ${className}`}>
        {children}
    </div>
);

const DialogTitle = ({ children, className = '' }) => (
    <h2 className={`text-lg font-semibold ${className}`}>
        {children}
    </h2>
);

export { Dialog, DialogTrigger, DialogContent, DialogHeader, DialogTitle };